<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style>
.scollTable .v-data-table__wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/* / Track / */
.scollTable .v-data-table__wrapper::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
  width: 10px;
}
/* / Handle / */
.scollTable .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #d9dbdb;
  border-radius: 10px;
}

/* / Handle on hover */
.scollTable .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #d9dbdb;
  border-radius: 10px;
}
</style>
